import { BotId } from '@feedyou/schema'
import { FeedbotMiddleware, isThunk } from '../types'
import { openBotIdSelector, openStepNlpTabsSelector, selectedHeaderTabSelector } from './selectors'
import { appActions } from './appSlice'
import { isTabContainedInList } from '../../features/botHeaderTabs'
import { topHeaderTabsSelector } from '../../features/botHeaderTabs/selectors'
import {
  isOnDisabledDevBotSelector,
  promptForDisabledDevResolution
} from '../../features/serverBots/actions/promptForDisabledDevResolution'
import { areFeatureValuesReadySelector } from '../features/selectors'
import { isStepNlpEnabledSelector } from '../flow/selectors/isStepNlpEnabledSelector'
import { botFlowSelector } from '../flow/selectors/botFlowSelector'
import { botHostingMetadataSelector } from '../../features/hostingVersions/selectors/botHostingMetadataSelector'

export const uiIntegrityMiddleware: FeedbotMiddleware =
  ({ dispatch, getState }) =>
  next =>
  action => {
    if (isThunk(action)) {
      return next(action)
    }

    if (!areFeatureValuesReadySelector(getState())) {
      return next(action)
    }

    const result = next(action)

    const state = getState()
    const openStepNlpTabs = openStepNlpTabsSelector(state)

    if (!isStepNlpEnabledSelector(state) && openStepNlpTabs.length) {
      dispatch(appActions.closeTabs(openStepNlpTabs))
    }

    const topHeaderTabs = topHeaderTabsSelector(state)
    const selectedHeaderTab = selectedHeaderTabSelector(state)
    const areFeatureValuesReady = areFeatureValuesReadySelector(state)
    const areSdkFeaturesReady = !!botHostingMetadataSelector(state)?.buildInfo?.sdkFeatures?.length

    const areFlagsReady = areSdkFeaturesReady && areFeatureValuesReady
    const selectedTabIsNoLongerOpen =
      !selectedHeaderTab || !isTabContainedInList(selectedHeaderTab, topHeaderTabs)

    if (areFlagsReady && selectedTabIsNoLongerOpen && !!botFlowSelector(state)?.id) {
      dispatch(appActions.selectTab({ tab: topHeaderTabs[0] }))
    }

    if (isOnDisabledDevBotSelector(state) && isOnFlowPage(openBotIdSelector(state))) {
      dispatch(promptForDisabledDevResolution())
    }

    return result
  }

function isOnFlowPage(botId?: BotId) {
  if (!botId) {
    return false
  }

  return (
    window.location.pathname.endsWith(`/bots/${botId}`) ||
    window.location.pathname.endsWith(`/bots/${botId}/`)
  )
}
